import { MatDialog } from '@angular/material/dialog';

/**
 * Checks if there are any open dialogs.
 *
 * @param dialog - The MatDialog instance to check for open dialogs.
 * @return True if there are open dialogs, false otherwise.
 */
export function hasOpenDialogs(dialog: MatDialog): boolean {
    return dialog.openDialogs.length > 0;
}
